import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import localImg from './assets/presence-map.png';
import { Container, Info, Divider, Image } from './styles';

export default function Locals() {
  const { t } = useTranslation();

  return (
    <Container>
      <Info>
        <header>
          <Typography component="span" variant="h1">
            {t(
              'Desde 2011 a Vialaser vem deixando as pessoas livres dos pelos indesejados',
            )}
          </Typography>
        </header>
        <Divider />
        <Typography component="div">
          {t(
            'Com clinicas espalhadas pelo Brasil, e ainda crescendo aceleradamente, a Vialaser prima por ser a empresa que traz a mais alta tecnologia para dentro dos seus ambientes Com o firme propósito de ajudar as pessoas a viverem mais felizes, amando suas peles A Vialaser renova suas máquinas de acordo com o que existe de mais avançado no mercado Além de utilizar a tecnologia para facilitar cada passo do relacionamento dos nossos clientes com a marca',
          )}
        </Typography>
        <Typography component="div">
          {t(
            'Hoje, estamos presentes nos seguintes estados do Brasil Pará, Sergipe, Santa Catarina, São Paulo, Rio Grande do Sul, Paraíba, Mato grosso do Sul, Paraná, Ceará, Pernambuco, Amazonas, Minas Gerais, Rio de Janeiro, Bahia, Maranhão e Piauí',
          )}
          <Typography component="p">
            {t('No Paraguai, estamos presentes na capital Assunção')}
          </Typography>
          <Typography component="p">
            {t('E também estamos presentes na Costa Rica')}
          </Typography>
          <br />
          <Typography component="p">
            {t('Em breve estaremos em muito mais estados e países!')}
          </Typography>
        </Typography>
      </Info>
      <Image src={localImg} />
    </Container>
  );
}
